import {ref} from "vue";
import useApi from "@/services/useApi";

export default function useActivationViberTelephony() {
    const activationStatusNumber = ref('')


    const initiateActivationViberTelephony = async (country) => {
        const {api, headers} = useApi();
        let result = null
        try {
            const response = await api.post('/api/activation/viber-voip', country, {headers})
            result = response.data.description

            switch (result) {
                case "Something went wrong":
                    activationStatusNumber.value = "oops";
                    break;
                case "Number successfully activated":
                    activationStatusNumber.value = "activated";
                    break;
                case "Pending number activation":
                case "Activation process initiated":
                case "Pending link generation":
                case "Number activation already in progress":
                case "Number activation initiated":
                    activationStatusNumber.value = "generationCode";
                    break;
                default:
                    activationStatusNumber.value = result;
                    break;
            }
        } catch (error) {
            return error.response?.data;
        }
    }

    return {
        initiateActivationViberTelephony,
        activationStatusNumber,
    }
}
